export default ({ color, fontSize, typography }) => ({
  applyBtn: {
    backgroundColor: `${color.primaryButtonBackground} !important`,
    borderColor: `${color.primaryButtonBackground} !important`,
    color: `${color.primaryButtonText} !important`,
    fontSize: fontSize.small,
    fontFamily: 'clear-sans-regular',
    height: 40,
    marginLeft: 20,
    '&:hover': {
      backgroundColor: `${color.primaryButtonHover} !important`,
      borderColor: `${color.primaryButtonHover} !important`,
    },
  },
  filter: {
    backgroundColor: color.white,
    position: 'absolute',
    zIndex: 100,
    height: '100%',
    width: '100%',
    borderBottom: '1px solid lightgrey !important',
  },
  filterRankContainer: {
    height: '100%',
    marginLeft: 24,
    marginRight: 20,
  },
  textInput: {
    width: 80,
    height: 40,
    display: 'inline-block',
    '& input': {
      borderBottom: 0,
      height: 39,
      width: '100%',
    },
    '&:hover div': {
      borderColor: '#c8d1e0',
    },
  },
  invalidTextInput: {
    '& input': {
      borderColor: color.borderColorError,
    },
    '&:focus div': {
      boxShadow: `0 0 0 1px #ffffff, 0 0 0 2px ${color.borderColorError}`,
    },
    '& input:focus + div': {
      boxShadow: `0 0 0 1px #ffffff, 0 0 0 2px ${color.borderColorError}`,
    },
    '& div': {
      borderColor: color.borderColorError,
    },
  },
  filterLabel: {
    fontSize: fontSize.small,
  },
  searchBar: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  label: {
    marginBottom: 5,
  },
  linkBtn: {
    borderColor: '#fff',
    border: 'none',
    height: '40px!important',
    background: 'none',
    outline: 'none',
    display: 'inline',
    color: color.primaryButtonBackground,
    fontSize: fontSize.small,
    textDecoration: 'none',
    '&:focus': {
      outline: 'none',
      boxShadow: 'none',
    },
  },
  linkBar: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: 20,
  },
  filterTypeContainer: {
    borderBottom: `1px solid ${color.borderColor}`,
    paddingLeft: 20,
    height: '10%',
    display: 'flex',
    alignItems: 'flex-end',
  },
  separatedBtn: {
    marginLeft: 20,
  },
  filterTypeBtn: {
    border: 'none',
    borderBottom: '2px solid rgba(0, 0, 0, 0)',
    background: '#fff',
    height: 26,
    color: color.link,
    minWidth: 50,
    padding: 0,
    fontFamily: typography.buttonText,
    fontSize: fontSize.buttonText,
    '&:focus': {
      boxShadow: 'none',
    },
    '& span': {
      padding: 0,
    },
  },
  filterTypeBtnSelected: {
    color: color.bodyText,
    borderBottom: `2px solid ${color.bodyText}`,
    padding: 0,
    borderRadius: 0,
    '&:hover': {
      color: color.bodyText,
    },
  },
  slots: {
    fontSize: 10,
  },
});